import React from 'react';

export type SportIconKey =
    | 'golf'
    | 'triathlon'
    | 'crossfit'
    | 'running'
    | 'long-jump'
    | 'para-track'
    | 'default';

const SPORT_ICONS: Record<SportIconKey, React.ReactElement> = {
    golf: (
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M6.5 1.5V14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
            <path d="M6.5 2H11.5L9.4 4L11.5 6H6.5V2Z" fill="currentColor" />
            <path d="M4.1 14.1C4.1 13.45 5.2 12.9 6.55 12.9C7.9 12.9 9 13.45 9 14.1C9 14.75 7.9 15.2 6.55 15.2C5.2 15.2 4.1 14.75 4.1 14.1Z" fill="currentColor" />
        </svg>
    ),
    triathlon: (
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M4 11.8C5 10.9 6.1 10.9 7.1 11.8C8.1 12.7 9.2 12.7 10.2 11.8C11.2 10.9 12.3 10.9 13.3 11.8" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
            <path d="M5.2 8.8L8 5.1L12.1 7.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.9 3.35C9.53 2.72 9.3 1.67 8.47 1.35C7.66 1.04 6.86 1.73 7.01 2.58C7.15 3.39 8.32 3.94 8.9 3.35Z" fill="currentColor" />
        </svg>
    ),
    crossfit: (
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M4 12.5L6.1 5.2L10 10.1L12.1 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 12.5H5.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M10.8 3.5H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    ),
    running: (
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <circle cx="10.4" cy="2.6" r="1.3" fill="currentColor" />
            <path d="M9.4 4.6L7.2 6.4L5.2 5.6L4.6 7L7 8L7.4 10.6L5.2 13.6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.4 10.6L9.6 12L11.4 14" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.4 4.6L11.6 6.6L13.6 6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    'long-jump': (
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <circle cx="9.6" cy="2.6" r="1.2" fill="currentColor" />
            <path d="M3 13L6.6 8.6L9 9.4L11 6.6L13.4 8" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2 13.6H14" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        </svg>
    ),
    'para-track': (
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <circle cx="9.6" cy="2.4" r="1.2" fill="currentColor" />
            <path d="M9.6 4.4L7.6 6.4L5.6 6V8L8 8.6L8.6 11" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="6.4" cy="12.4" r="2.4" stroke="currentColor" strokeWidth="1.2" />
            <path d="M6.4 10V12.4L8.4 13.4" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
        </svg>
    ),
    default: (
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M8.8 3.15C9.45 2.5 9.22 1.4 8.36 1.08C7.52 0.76 6.69 1.48 6.84 2.36C6.99 3.2 8.2 3.76 8.8 3.15Z" fill="currentColor" />
            <path d="M5.94 5.54L7.52 3.98L10.46 4.8L12.72 3.72L13.42 5.02L10.7 6.32L9.54 6L10.78 8.16L13.08 9.02L12.54 10.5L9.64 9.42L8.62 7.72L7.34 9.4L7.02 13.26H5.46L5.82 8.82L7.12 7.02L5.98 6.72L4.34 8.16L3.38 7.08L5.94 5.54Z" fill="currentColor" />
        </svg>
    ),
};

export function SportIcon({ iconKey }: { iconKey: SportIconKey }) {
    return SPORT_ICONS[iconKey];
}
